import { Skeleton } from "@/components/ui/skeleton";

export function ProjectCardSkeleton() {
  return (
    <div className="rounded-3xl glass p-2" data-testid="project-card-skeleton">
      <Skeleton className="h-60 sm:h-72 w-full rounded-2xl" />
      <div className="px-4 py-4 space-y-3">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <div className="flex gap-1.5 pt-1">
          <Skeleton className="h-6 w-14 rounded-md" />
          <Skeleton className="h-6 w-16 rounded-md" />
          <Skeleton className="h-6 w-12 rounded-md" />
        </div>
      </div>
    </div>
  );
}

export function ProjectGridSkeleton({ count = 3 }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="project-grid-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <ProjectCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function SkillCardSkeleton() {
  return (
    <div className="glass rounded-3xl p-8 h-full" data-testid="skill-card-skeleton">
      <div className="flex items-baseline gap-3 mb-6">
        <Skeleton className="h-4 w-6 rounded-md" />
        <Skeleton className="h-6 w-2/5 rounded-md" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="flex flex-col gap-2 p-3 rounded-2xl bg-secondary/25 border border-border/5">
            <div className="flex justify-between items-center">
              <Skeleton className="h-4 w-1/2 rounded-md" />
              <Skeleton className="h-3.5 w-8 rounded-md" />
            </div>
            <Skeleton className="h-1.5 w-full rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkillGridSkeleton({ count = 4, cols = "md:grid-cols-2" }) {
  return (
    <div className={`grid ${cols} gap-6`} data-testid="skill-grid-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <SkillCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function ProjectDetailSkeleton() {
  return (
    <div data-testid="project-detail-skeleton">
      <Skeleton className="h-[42vh] sm:h-[56vh] max-h-[560px] w-full rounded-none" />
      <div className="max-w-6xl mx-auto px-6">
        <div className="-mt-24 relative space-y-4">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-12 sm:h-16 w-4/5 rounded-xl" />
          <Skeleton className="h-5 w-2/3" />
          <div className="flex gap-3 pt-2">
            <Skeleton className="h-10 w-32 rounded-full" />
            <Skeleton className="h-10 w-32 rounded-full" />
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 py-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-8 space-y-12">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="space-y-3">
              <Skeleton className="h-3 w-28" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-11/12" />
              <Skeleton className="h-4 w-3/4" />
            </div>
          ))}
        </div>
        <div className="lg:col-span-4">
          <div className="glass rounded-3xl p-6 space-y-4">
            <Skeleton className="h-3 w-24" />
            <div className="flex flex-wrap gap-2">
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} className="h-6 w-16 rounded-md" />
              ))}
            </div>
            <Skeleton className="h-10 w-full rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function AdminDashboardSkeleton() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-6" data-testid="admin-dashboard-skeleton">
      <div className="flex items-center justify-between mb-8">
        <div className="space-y-2">
          <Skeleton className="h-7 w-48" />
          <Skeleton className="h-4 w-40" />
        </div>
        <Skeleton className="h-9 w-24 rounded-full" />
      </div>
      <div className="grid lg:grid-cols-[220px_1fr] gap-8">
        <div className="flex lg:flex-col gap-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="h-10 w-full lg:w-full min-w-[100px] rounded-xl" />
          ))}
        </div>
        <div className="space-y-3">
          <Skeleton className="h-7 w-40 mb-4" />
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-20 w-full rounded-xl" />
          ))}
        </div>
      </div>
    </div>
  );
}
